import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoadingOverlay } from '@/components/elements/LoadingOverlay';
import { ShareDeviceLayout } from '@/components/layouts/ShareDeviceLayout';
import { ROUTE_PATH } from '@/constants/routes';
import { useAuth } from '@/hooks/useAuth';
import { useDialog } from '@/hooks/useDialog';
import { useUser } from '@/hooks/useUser';

export const ShareDeviceMe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { user, isLoading, error } = useUser();
  const logoutDialog = useDialog();

  const handleLogoutClick = () => {
    logoutDialog.open();
  };

  const handleLogoutConfirm = () => {
    logoutDialog.close();
    logout();
    navigate(ROUTE_PATH.LOGIN);
  };

  const handleLogoutCancel = () => {
    logoutDialog.close();
  };

  return (
    <ShareDeviceLayout>
      {isLoading && <LoadingOverlay message={t('shareDevice.me.loading')} />}

      <div className="page page_f7">
        <main className="page__main">
          <div className="page__content">
            <section className="f7">
              <div className="f7__line">
                <div className="f7__inner">
                  <div className="f7__area">
                    <h1 className="f7__title">{t('shareDevice.me.title')}</h1>

                    {error && (
                      <div className="f7__alert f7__alert--error">
                        {t('shareDevice.me.error')}
                      </div>
                    )}

                    {user && (
                      <div className="f7__user-info">
                        <div className="f7__info-item">
                          <span className="f7__info-label">
                            {t('shareDevice.me.userInfo.email')}
                          </span>
                          <span className="f7__info-value">{user.email}</span>
                        </div>
                      </div>
                    )}

                    <div className="f7__actions">
                      <button
                        type="button"
                        className="f7__btn f7__btn--logout"
                        onClick={handleLogoutClick}
                      >
                        {t('shareDevice.me.logoutButton')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>

      <dialog className="dialog dialog--logout" ref={logoutDialog.dialogRef}>
        <div className="dialog__content">
          <h2 className="dialog__title">
            {t('shareDevice.me.logoutDialog.title')}
          </h2>
          <div className="dialog__actions">
            <button
              type="button"
              className="dialog__btn dialog__btn--primary"
              onClick={handleLogoutConfirm}
            >
              {t('shareDevice.me.logoutDialog.yes')}
            </button>
            <button
              type="button"
              className="dialog__btn dialog__btn--secondary"
              onClick={handleLogoutCancel}
            >
              {t('shareDevice.me.logoutDialog.no')}
            </button>
          </div>
        </div>
      </dialog>
    </ShareDeviceLayout>
  );
};
